import { inject } from "@angular/core";
import { CanActivateFn, RedirectCommand, Router } from "@angular/router";

export const appleAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

//HANDLE APPLE (data returns in queryParams)
    const apple_token = route.queryParamMap.get('id_token');
        
    console.log('%c OLD ROUTE GUARD START', 'color:lime;background:black;', route);
    if(apple_token && !route.queryParamMap.has('handled')){
        const appleState = route.queryParamMap.get('state');
        const appleQueryParams:Record<string, any> = {};
        if(appleState){
            const parsedState = JSON.parse(appleState);
            Object.entries(parsedState).forEach(([key, value])=>appleQueryParams[key] = value);
        }
        appleQueryParams['handled'] = 'true';
        appleQueryParams['apple_token'] = apple_token;

        let destination = '/profile';
        if(appleQueryParams['destination'] === 'p'){
            destination = '/p'
        }
      const newUrl = router.createUrlTree([destination], { queryParams: appleQueryParams} );
      console.log('%c OLD ROUTE GUARD APPLE REDIRECT', 'color:lime;background:black;', {route, newUrl});
      return new RedirectCommand(newUrl);
    }
   
    return true;
};